import { httpClient, ROOT_URL } from '../../App';
import { message } from 'antd';
import type { Key } from 'react';
import { getErrorMessage } from '../../api/error';
import { useCallback } from 'react';

interface IResult {
  bulkApprove: (ids: Key[]) => Promise<void>;
}

export const usePaymentRequestBulkApprove = (): IResult => {
  const bulkApprove = useCallback(async (ids: Key[]): Promise<void> => {
    try {
      await httpClient.put(`${ROOT_URL}/api/v1/payment_requests/bulk-approve`, {
        ids,
      });
    } catch (error) {
      message.error(getErrorMessage(error));
    }
  }, []);

  return { bulkApprove };
};
